import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { TikTokIcon } from './TikTokIcon';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-primary-dark text-white/70 py-14" data-id="element-165" data-mp="32p5nojgp12qd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166" data-mp="36p6d0z5byyc7">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-167" data-mp="36ppn5toqoifo">
          <div data-id="element-168" data-mp="3ug3gromz2pcd">
            <span className="font-serif text-2xl font-bold text-white block mb-2" data-id="element-169" data-mp="3ufjww2drhqvp">
              Cabañas Clarita
            </span>
            <p className="text-sm leading-relaxed" data-id="element-170" data-mp="36d26u3xsnlq">
              {t('Los Notros 861, Dina Huapi, Río Negro · Patagonia Argentina', 'Los Notros 861, Dina Huapi, Río Negro · Argentine Patagonia')}
            </p>
          </div>

          <nav aria-label={t('Enlaces del sitio', 'Site links')} data-id="element-171" data-mp="29xvrqfdrbhqd">
            <span className="block text-sm font-medium text-white mb-3" data-id="element-172" data-mp="2ezbb830adg6n">
              {t('Navegación', 'Navigation')}
            </span>
            <ul className="space-y-2 text-sm" data-id="element-173" data-mp="3lbmsnnzpv0ds">
              <li data-id="element-174" data-mp="3gb8vj0znlauj">
                <a href="#cabanas" className="hover:text-white transition-colors" data-id="element-175" data-mp="3gbr0cm0dsxe2">
                  {t('Cabañas', 'Cabins')}
                </a>
              </li>
              <li data-id="element-176" data-mp="3q8wq9qx9eicp">
                <a href="#servicios" className="hover:text-white transition-colors" data-id="element-177" data-mp="3q8dhp0ti16bc">
                  {t('Servicios', 'Services')}
                </a>
              </li>
              <li data-id="element-178" data-mp="33e71cf6sut9">
                <a href="#actividades" className="hover:text-white transition-colors" data-id="element-179" data-mp="31uqdkpmchqy">
                  {t('Actividades', 'Activities')}
                </a>
              </li>
              <li data-id="element-180" data-mp="qt8hjnc1a7ac">
                <a href="#resenas" className="hover:text-white transition-colors" data-id="element-181" data-mp="qsqea6qyessx">
                  {t('Reseñas', 'Reviews')}
                </a>
              </li>
              <li data-id="element-182" data-mp="mq3jbwyzkrri">
                <a href="#ubicacion" className="hover:text-white transition-colors" data-id="element-183" data-mp="tvmr3jy8gkmy">
                  {t('Ubicación', 'Location')}
                </a>
              </li>
              <li data-id="element-184" data-mp="13s9980z6cxla">
                <a href="#contacto" className="hover:text-white transition-colors" data-id="element-185" data-mp="13rptmqwzylaf">
                  {t('Contacto', 'Contact')}
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-186" data-mp="1cl2rm79x4d3d">
            <span className="block text-sm font-medium text-white mb-3" data-id="element-187" data-mp="1cnp0qbcgj0np">
              {t('Contacto', 'Contact')}
            </span>
            <ul className="space-y-2 text-sm" data-id="element-188" data-mp="1mk1tn706hahe">
              <li data-id="element-189" data-mp="1mkbigr9hlbli">
                <a href="mailto:reservas@cabanasclarita.com" className="hover:text-white transition-colors break-all" data-id="element-190" data-mp="1mhpaiqioou2r">
                  reservas@cabanasclarita.com
                </a>
              </li>
              <li data-id="element-191" data-mp="3tb9kdl72dhrn">
                <a href="tel:+5492944727449" className="hover:text-white transition-colors" data-id="element-192" data-mp="3tarr8xfp7jny">
                  (+54) 9 294 4727449
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-4" data-id="element-193" data-mp="21mths6ob0u1b">
              <a href="https://www.instagram.com/cabaniasclarita/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:text-white hover:border-white/50 transition-colors" aria-label="Instagram" data-id="element-194" data-mp="21nlc7e660lq0">
                <Instagram className="w-4 h-4" data-id="element-195" data-mp="2kcrwh5mlxldx" />
              </a>
              <a href="https://www.facebook.com/p/Caba%C3%B1as-Clarita-100063679114396/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:text-white hover:border-white/50 transition-colors" aria-label="Facebook" data-id="element-196" data-mp="2kf4grpfu87u5">
                <Facebook className="w-4 h-4" data-id="element-197" data-mp="2rtwmg0o0owb9" />
              </a>
              <a href="https://www.tiktok.com/@cabaasclarita" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:text-white hover:border-white/50 transition-colors" aria-label="TikTok" data-id="element-198" data-mp="2wn96dxhr4exo">
                <TikTokIcon className="w-4 h-4" data-id="element-199" data-mp="3fltwpnbtjga9" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-xs" data-id="element-200" data-mp="31khh5d0klgow">
          <p data-id="element-201" data-mp="36kdl5c99p84g">
            &copy; {new Date().getFullYear()} Cabañas Clarita.{' '}
            {t('Todos los derechos reservados.', 'All rights reserved.')}
          </p>
        </div>
      </div>
    </footer>;
}